import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Hidden from '@material-ui/core/Hidden';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Title from '../../../components/atoms/Title';
import Picture from '../../../components/atoms/Picture';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Link from '../../../components/atoms/Link';
import { getHelperKeysFromDictionary } from '../../../../utils/utility';
import { dictionaryKeys } from './constants';
import Typography from '../../../components/atoms/Typography';
import Grid from '../../../components/molecules/Grid';
import Container from '../../../components/molecules/Container';
import Box from '../../../components/molecules/Box';
import ReviewCard from '../../../components/molecules/ReviewCard';
import * as locators from './locators';
import { replaceKeysLabelText } from '../../../../utils/utility';
import { checkForPropsValue, addHttpsImagePath } from './preProcess';
import useStyles from './style';
import fetchService from '../../../../services/FetchService';
import { modifyApi } from '../../../../utils/urls';
import { canUseDOM } from '../../../utils/canUseDOM';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import { createDynamicLabels } from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { numToKilo } from '../../../utils/numToKilo';

const TripAdvisor = props => {
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const [reviewsData, setReviewsData] = useState({});
  const dictionary = props && props.t;
  const helperKeys = getHelperKeysFromDictionary(dictionary, dictionaryKeys);
  const {
    readmore,
    numberOfReviewsLabel,
    tripAdvisorPreText,
    readReviewLabel,
    writeReviewLabel,
    reviewByLabel,
    tripAdvisorComponentTitle,
  } = helperKeys;
  // const locationId = {
  //   value: '9729389',
  // };
  const locationId = checkForPropsValue(
    get(props, 'fields.locationId', ''),
    get(props, 'sitecoreContext.route.fields.locationId', '')
  );
  // const tripAdvisorComponentTitle = checkForPropsValue(
  //   get(props, 'fields.tripAdvisorTitle', ''),
  //   get(props, 'sitecoreContext.route.fields.tripAdvisorTitle', ''),
  //   helperKeys.tripAdvisorComponentTitle
  // );
  const tripAdvisorComponentDescription = checkForPropsValue(
    get(props, 'fields.tripAdvisorDescription', ''),
    get(props, 'sitecoreContext.route.fields.tripAdvisorDescription', ''),
    helperKeys.tripAdvisorComponentDescription
  );
  const selectedLanguage = get(props, 'sitecoreContext.language', 'en');

  let language = selectedLanguage && selectedLanguage.split('-');
  language = language.length > 0 && language[0];

  const classes = useStyles(props);
  const { appConfig = {} } = props;

  const {
    reviews,
    write_review,
    web_url,
  } = reviewsData || {};
  const showReviews = () => {
    let sortedReviews = reviews.sort((a, b) => {
      if (a.rating === b.rating && a.published_date && b.published_date) {
        return new Date(b.published_date) - new Date(a.published_date);
      } else {
        return a.rating && b.rating && b.rating - a.rating;
      }
    });
    if (sortedReviews && sortedReviews.length > 3) {
      sortedReviews = sortedReviews.slice(0, 3);
    }
    return sortedReviews.map((item, index) => (
      <div className="review-cards" key={index}>
        <ReviewCard
          sectionTitle={tripAdvisorComponentTitle}
          reviewByLabel={reviewByLabel}
          readmore={readmore}
          componentName={componentName}
          pageName={pageName}
          language={language}
          {...item}
        ></ReviewCard>
      </div>
    ));
  };
  const tripAdvisorNumberOfReviews = get(props, 'sitecoreContext.route.fields.tripAdvisorNumberOfReviews.value', '');
  const tripAdvisor = {
    imageUrl: {
      value: {
        src: addHttpsImagePath(get(props, 'sitecoreContext.route.fields.tripAdvisorRatingImageURL.value', '')),
        alt: tripAdvisorNumberOfReviews,
      },
    },
    numberOfReviews: tripAdvisorNumberOfReviews,
  };
  useEffect(() => {
    if (canUseDOM && locationId) {
      fetchService({
        url: modifyApi(appConfig.TRIP_ADVISOR_API, {
          language,
          location: locationId.value,
        }),
      })
        .then(response => {
          const { data } = response;
          data && setReviewsData(data);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [language, locationId]);

  return get(reviewsData, 'reviews.length') > 0 ? (
    <Box
      component="div"
      className={classes.root}
      data-locator={locators.COMPONENT_NAME}
    >
      <Container>
        <Box component="div" className={classes.headingSection}>
          <Grid className={classes.headingGrid}>
            {tripAdvisorPreText && (
              <Title text={tripAdvisorPreText} className={classes.heading} />
            )}
            {tripAdvisorComponentTitle && (
              <Typography
                variant="h2"
                className={classes.tripAdvisorTitle}
                component="h2"
                noWrap
              >
                <Text field={tripAdvisorComponentTitle} />
              </Typography>
            )}
            {tripAdvisorComponentDescription && (
              <Typography
                variant="body1"
                className={classes.description}
                component="p"
              >
                <Text field={tripAdvisorComponentDescription} />
              </Typography>
            )}
            <Box className={classes.overViewSection}>
              <Box component="div" className={classes.ratingImageWithLogo}>
                <Picture
                  className={classes.rating}
                  media={{
                    image: tripAdvisor.imageUrl,
                    renditionNeeded: false,
                    fallbackBackgroundNeeded: false,
                  }}
                  alternateAltText={
                    tripAdvisor.numberOfReviews
                  }
                  isParalax={false}
                />
              </Box>
              {tripAdvisor.numberOfReviews && (
                <Typography
                  variant="body2"
                  component="span"
                  className={classes.totalReviews}
                >
                  <Text
                    field={replaceKeysLabelText(numberOfReviewsLabel, [
                      numToKilo(tripAdvisor.numberOfReviews),
                    ])}
                  ></Text>
                </Typography>
              )}

              <Typography
                variant="body2Bold"
                component="div"
                className={classes.editReviews}
              >
                <Link
                  isCustom={true}
                  customHref={web_url}
                  target="_blank"
                  isExternalLink={true}
                  className={classes.readReviews}
                  data-id={get(
                    analyticsData,
                    'dataIds.pageBodyNavLinkClick',
                    ''
                  )}
                  data-link={createDynamicLabels([
                    componentName,
                    pageName,
                    `${readReviewLabel && readReviewLabel.value}`,
                  ])}
                >
                  <Text field={readReviewLabel}></Text>
                </Link>
                <Link
                  isCustom={true}
                  customHref={write_review}
                  target="_blank"
                  isExternalLink={true}
                  data-id={get(
                    analyticsData,
                    'dataIds.pageBodyNavLinkClick',
                    ''
                  )}
                  data-link={createDynamicLabels([
                    componentName,
                    pageName,
                    `${writeReviewLabel && writeReviewLabel.value}`,
                  ])}
                >
                  <Text field={writeReviewLabel}></Text>
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Box>
        <Box component="div" className={classes.reviewsSection}>
          <Hidden className={classes.reviews} lgUp implementation="css">
            {reviews && reviews.length > 0 && showReviews()}
          </Hidden>
          <Hidden mdDown implementation="css">
            <Grid className={classes.deskTopReviews}>
              {reviews && reviews.length > 0 && showReviews()}
            </Grid>
          </Hidden>
        </Box>
      </Container>
    </Box>
  ) : null;
};

TripAdvisor.propTypes = {
  fields: PropTypes.shape({
    tripAdvisorComponentDescription: PropTypes.shape({
      value: PropTypes.string,
    }),
    tripAdvisorComponentTitle: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

TripAdvisor.defaultProps = {
  fields: PropTypes.shape({
    tripAdvisorComponentDescription: { value: '' },
    tripAdvisorComponentTitle: { value: '' },
  }),
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(TripAdvisor))
);
